import React from 'react';

interface FitToWidthIconProps {
    className?: string;
}

const FitToWidthIcon: React.FC<FitToWidthIconProps> = ({ className = "w-4 h-4" }) => (
    <svg className={className} fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
        <path d="M9 4H6a2 2 0 0 0-2 2v3" />
        <path d="M15 4h3a2 2 0 0 1 2 2v3" />
        <path d="M9 20H6a2 2 0 0 1-2-2v-3" />
        <path d="M15 20h3a2 2 0 0 0 2-2v-3" />
        <circle cx="12" cy="12" r="2.5" />
    </svg>
);

export default FitToWidthIcon;
